// src/components/dashboard/StatusBadge.js
// Normalizes registrations.status (lowercase: pending/assigned/approved/
// rejected/deregistered) into a consistent label + color across dashboards.
import React from 'react';
import { Badge } from 'react-bootstrap';

const STATUS_MAP = {
  pending: { label: 'Requested', variant: 'warning' },
  assigned: { label: 'Assigned', variant: 'info' },
  approved: { label: 'Approved', variant: 'success' },
  rejected: { label: 'Rejected', variant: 'danger' },
  deregistered: { label: 'Removed', variant: 'secondary' },
};

function StatusBadge({ status }) {
  if (!status) return null;
  const meta = STATUS_MAP[String(status).toLowerCase()] || { label: status, variant: 'secondary' };
  return <Badge bg={meta.variant}>{meta.label}</Badge>;
}

export default StatusBadge;
